import { Pipe, PipeTransform } from "@angular/core";
import { TransactionTypeEnum } from "@models/transaction";

@Pipe({
  name: "transactionTypeEnum",
  standalone: true,
})
export class TransactionTypeEnumPipe implements PipeTransform {
  transform(value: TransactionTypeEnum): string {
    switch (value) {
      case TransactionTypeEnum.SAQUE:
        return "Saque";
      case TransactionTypeEnum.VENDA:
        return "Venda";
      case TransactionTypeEnum.EXTORNO:
        return "Extorno";
      case TransactionTypeEnum.MULTA_CANCELAMENTO:
        return "Multa de cancelamento";
      case TransactionTypeEnum.PDV_RECEIVED:
        return "Recebimento PDV";
      case TransactionTypeEnum.PDV_FEE:
      case TransactionTypeEnum.PDV_FEE_DEBIT:
        return "Comissão PDV Evento";
      case TransactionTypeEnum.PDV_REFUND:
        return "Estorno PDV";
      case TransactionTypeEnum.PDV_FEE_REVERSAL:
      case TransactionTypeEnum.PDV_FEE_DEBIT_REVERSAL:
        return "Reversão de comissão PDV Evento";
      default:
        return value;
    }
  }
}
